import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "contentId", "hasFooterLogo", "parentProduct", "spaceKey"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl-next';
import { ClassNames } from '@emotion/core';
import { Experience, ExperienceTrackerContext } from '@atlassian/experience-tracker';
import { ExperienceNames, useExperienceTracker, useSetUpExperience } from '../experience-tracker';
import { Iframe } from '../iframe';
import { EMBEDDED_CONFLUENCE_MODE, EMBEDDED_PARENT_PRODUCTS, Footer, PageLoadValidation, useUrl, useContentSize } from '../page-common';
var StyledEmbeddedPageContainer = function StyledEmbeddedPageContainer(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isHeightSetFromC = _ref.isHeightSetFromContent,
    isHeightSetFromContent = _ref$isHeightSetFromC === void 0 ? false : _ref$isHeightSetFromC;
  var _useContentSize = useContentSize(isHeightSetFromContent),
    height = _useContentSize.height;
  return /*#__PURE__*/React.createElement(ClassNames, null, function (_ref2) {
    var css = _ref2.css,
      cx = _ref2.cx;
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css({
        display: 'flex',
        flexDirection: 'column',
        height: isHeightSetFromContent ? "".concat(height, "px") : '100%'
      }), className)
    }, children);
  });
};
var ViewPageImpl = function ViewPageImpl(props) {
  var className = props.className,
    contentId = props.contentId,
    _props$hasFooterLogo = props.hasFooterLogo,
    hasFooterLogo = _props$hasFooterLogo === void 0 ? true : _props$hasFooterLogo,
    parentProduct = props.parentProduct,
    spaceKey = props.spaceKey,
    passThroughProps = _objectWithoutProperties(props, _excluded);
  var experienceTracker = useExperienceTracker();
  useSetUpExperience({
    experienceTracker: experienceTracker,
    contentId: contentId,
    spaceKey: spaceKey,
    experience: ExperienceNames.VIEW_PAGE,
    ccExperience: ExperienceNames.CC_VIEW_PAGE
  });
  var _useUrl = useUrl(_objectSpread(_objectSpread({}, props), {}, {
      mode: EMBEDDED_CONFLUENCE_MODE.VIEW_MODE
    })),
    standaloneConfluenceUrl = _useUrl.standaloneConfluenceUrl,
    embeddedConfluenceUrl = _useUrl.embeddedConfluenceUrl;
  var _useState = useState(standaloneConfluenceUrl),
    _useState2 = _slicedToArray(_useState, 2),
    footerUrl = _useState2[0],
    setFooterUrl = _useState2[1];
  useEffect(function () {
    setFooterUrl(standaloneConfluenceUrl);
  }, [standaloneConfluenceUrl]);
  useEffect(function () {
    experienceTracker.subscribe(function (event) {
      var name = event.name,
        action = event.action;
      if (name === ExperienceNames.PAGE_NOT_FOUND && action === 'taskStart') {
        setFooterUrl(standaloneConfluenceUrl ? "".concat(new URL(standaloneConfluenceUrl).origin, "/wiki/home") : standaloneConfluenceUrl);
      }
    });
  }, [experienceTracker, standaloneConfluenceUrl]);

  /**
   * Currently footer is hidden for the JSM Portal view which passes
   * hasFooterLogo prop as false and shown for all other views
   *
   * JSM portal view will provide "JSM-Portal" as the parent product eventually
   * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
   * We need to support these two parent product keys to keep backward compatibile for the time being.
   *
   * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
   */
  var showFooter = !((parentProduct === EMBEDDED_PARENT_PRODUCTS.JSM_PORTAL || parentProduct === EMBEDDED_PARENT_PRODUCTS.JSM) && !hasFooterLogo);
  return /*#__PURE__*/React.createElement(ExperienceTrackerContext.Provider, {
    value: experienceTracker
  }, /*#__PURE__*/React.createElement(Experience, {
    name: ExperienceNames.VIEW_PAGE
  }, /*#__PURE__*/React.createElement(PageLoadValidation, _extends({
    mode: EMBEDDED_CONFLUENCE_MODE.VIEW_MODE
  }, props), function (_ref3) {
    var handleIframeOnLoad = _ref3.handleIframeOnLoad,
      handleContentLoadStarted = _ref3.handleContentLoadStarted,
      navigationPolicy = _ref3.navigationPolicy,
      handleIframeUnload = _ref3.handleIframeUnload,
      redirectedToLogin = _ref3.redirectedToLogin;
    return /*#__PURE__*/React.createElement(StyledEmbeddedPageContainer, {
      className: className,
      isHeightSetFromContent: passThroughProps.isHeightSetFromContent
    }, embeddedConfluenceUrl && /*#__PURE__*/React.createElement(Iframe, _extends({
      parentProduct: parentProduct,
      src: redirectedToLogin ? '' : embeddedConfluenceUrl,
      onLoad: handleIframeOnLoad,
      onUnload: handleIframeUnload,
      onContentLoadStarted: handleContentLoadStarted
    }, passThroughProps, {
      navigationPolicy: navigationPolicy
    })), showFooter && /*#__PURE__*/React.createElement(Footer, {
      url: footerUrl
    }));
  })));
};
export var ViewPage = injectIntl(ViewPageImpl, {
  enforceContext: false
});